import { StoreState } from "../";

export const getMetaFlight = (store: StoreState) => store.metaFlightDetails.flight;
